export default {"src":"__ASTRO_ASSET_IMAGE__B15WT4lG__","width":3500,"height":1450,"format":"webp"}